import { render, staticRenderFns } from "./modal_detallesNorma.vue?vue&type=template&id=71186ab1&"
import script from "./modal_detallesNorma.vue?vue&type=script&lang=js&"
export * from "./modal_detallesNorma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports